<template>
  <div>
    <b-link
      @click="signInWithApple"
      :class="{ onlyIcon: onlyIcon }"
      class="btn-social apple-btn"
    >
      <b-img
        :class="{ onlyIcon: onlyIcon }"
        :src="getImage"
        :alt="$t('continueWithApple')"
      ></b-img>
      <template v-if="!onlyIcon">
        {{ $t("continueWithApple") }}
      </template>
    </b-link>
  </div>
</template>

<script>
import helpers from "@/helpers";
export default {
  props: {
    appleAccountNotMatch: {
      type: Function,
      default: null
    },
    connectValue: {
      type: String,
      default: null
    },
    onlyIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getImage() {
      return !this.onlyIcon
        ? `${this.publicPath}assets/images/icons/icon-apple.svg`
        : `${this.publicPath}assets/images/apple.png`;
    }
  },
  mounted() {
    window.AppleID.auth.init({
      clientId: process.env.VUE_APP_APPLE_CLIENT_ID,
      scope: "name email",
      redirectURI: process.env.VUE_APP_ACCOUNT_REDIRECT,
      usePopup: true
    });
    document.addEventListener("AppleIDSignInOnSuccess", this.handleSuccess);
    document.addEventListener("AppleIDSignInOnFailure", error => {
      console.log("signInError", error);
    });
  },
  methods: {
    signInWithApple() {
      window.AppleID.auth.signIn();
    },
    handleSuccess(data) {
      try {
        const idToken = helpers.parseJwt(data.detail.authorization.id_token);
        const userID = idToken.sub;
        if (userID === this.connectValue) {
          this.accountNotMatch = false;
          this.$router
            .push({
              name: "DeleteAccount",
              query: this.$route.query
            })
            .catch(() => {});
        } else {
          window.close();
          // this.appleAccountNotMatch(true);
          this.$emit("appleAccountAuth", {
            code: data.detail.authorization.code
          });
        }
      } catch (error) {
        console.log(error, "success Error");
      }
    }
  }
};
</script>

<style>
.signin-button {
  background-color: green !important;
}
#appleid-signin {
  background-color: transparent !important;
}
#appleid-signin div {
  background-color: transparent !important;
}
.btn-social {
  max-width: 48px;
  max-height: 48px;
  height: 28px;
  width: 28px;
}
</style>
